import React from 'react'
import Navbar from "../layouts/Navbar"
import Footer from "../layouts/Footer"
import styled from 'styled-components'
import { makeStyles, withStyles } from '@material-ui/core/styles';
// import Accordion from '@material-ui/core/Accordion';
// import AccordionSummary from '@material-ui/core/AccordionSummary';
// import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiTypography from '@material-ui/core/Typography';
import bg from "../../assets/images/illustrations/bg.png";
import book from "../../assets/images/illustrations/book2.png";
// import document from "../../assets/images/illustrations/document.png";

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        margin: 'auto',
        position: 'relative',
    },
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
    },
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

const Typography = withStyles((theme) => ({
    root: {
        fontSize: '16px',
        fontWeight: theme.typography.fontWeightRegular,
        fontFamily: 'Rubik',
        fontStyle: 'normal',
        '@media(max-width:900px)': {
            fontSize: '15px',
        },
        '@media(max-width:700px)': {
            fontSize: '14px',
        }
    },
}))(MuiTypography);

// const useStyles = makeStyles((theme) => ({
//     root: {
//         width: '100%',
//     },
//     heading: {
//         fontSize: '15px',
//         fontWeight: theme.typography.fontWeightRegular,
//         fontFamily: 'Rubik',
//         fontStyle: 'normal',
//         '@media(max-width:600px)': {
//             fontSize: '14px',
//         }
//     },
//     text: {
//         fontFamily: 'Rubik',
//         fontStyle: 'normal',
//         '@media(max-width:600px)': {
//             fontSize: '15px',
//         }
//     }
// }));

const FAQs = () => {

    // const [expanded, setExpanded] = React.useState('panel1');

    // const handleChange = (panel) => (event, newExpanded) => {
    //     setExpanded(newExpanded ? panel : false);
    // };

    window.scrollTo(0, 0);
    return (
        <>
            <div style={{ minHeight: "100vh" }}>
                <Navbar />
                <Main>
                    <Bg src={bg} />
                    <Title>How can we help you?</Title>
                    <Head>FAQs</Head>
                    <Accordion expanded={true} >
                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                            <Typography>Collapsible Group Item #1</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                                sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                                elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={true} >
                        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
                            <Typography>Collapsible Group Item #2</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                                sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                                elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={true} >
                        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
                            <Typography>Collapsible Group Item #3</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse malesuada lacus ex,
                                sit amet blandit leo lobortis eget. Lorem ipsum dolor sit amet, consectetur adipiscing
                                elit. Suspendisse malesuada lacus ex, sit amet blandit leo lobortis eget.
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </Main>
            </div>
            <hr style={{ margin: 0, height: "0.8px" }} />
            <Footer />
        </>
    )
}
export default FAQs;

const Main = styled.div`
    font-family: Rubik;
    font-style: normal;
    margin: 50px 32px;
    @media(max-width:600px){
        margin: 50px 12px;
    }
`

const Head = styled.p`
    font-weight: bold;
    font-size: 17px;
    margin-top: 61px;
    // margin-top: 80px;
    @media(max-width:900px){
        font-size: 16px;
    margin-top: 26px;
    }
    @media(max-width:700px){
        font-size: 15px;
    margin-top: 0px;
    }
    @media(max-width:500px){
        text-align: center;
        margin-bottom:0;
        padding-top: 34px;
    }
`
const Bg = styled.img`
    position: absolute;
    width: 800px;
    left: 50%;
    transform: translate(-50%, 0);
    @media(max-width:900px){
        width: 600px;
    }
    @media(max-width:700px){
        width: 450px;
    }
    @media(max-width:450px){
        width: 350px;
        margin-top:23px;
    }
`
const Title = styled.h1`
    font-weight: 600;
    font-size: 28px;
    color: #0842a0;
    text-align: center;
    padding-top: 50px;
    @media(max-width:900px){
        font-size: 24px;
    padding-top: 45px;
    }
    @media(max-width:700px){
        font-size: 20px;
        padding-top: 34px;
    }
    @media(max-width:500px){
        font-size: 20px;
        padding-top: 0px;
    }
`